import { authAPI } from './apiService'
import { AttributeText } from './models'

export type GetAttributeTextsResponse = {
    attributeTexts: AttributeText[];
}

const URL = '/attribute-texts'

const attributeTextsService = {

  get: () => authAPI
    .get<GetAttributeTextsResponse>(URL)
    .then((response) => response.data),

  create: (name: string, layerIds: number[]) => authAPI
    .post(`${URL}/create`, { name, layerIds })
    .then((response) => response.data),

  update: (id: number, name: string, layerIds: number[]) => authAPI
    .post(`${URL}/update`, { id, name, layerIds })
    .then((response) => response.data)

}

export default attributeTextsService
